import { render } from "./service-header.vue?vue&type=template&id=32c646de"
import script from "./service-header.vue?vue&type=script&lang=js"
export * from "./service-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__